export default __webpack_public_path__ + "static/media/advisor-hl.0b4c4fa3.jpg";